import { useState } from 'react';
import { useDashboard } from '../hooks/useDashboard';
import { useCache } from '../hooks/useCache';
import { fetchSOP } from '../api';
import KpiGrid           from '../components/ui/KpiGrid';
import TabKpiRow         from '../components/ui/TabKpiRow';
import PageSubnav        from '../components/layout/PageSubnav';
import StorePerformance  from '../components/storePerformance/StorePerformance';
import FootfallDirectory from '../components/footfallDirectory/FootfallDirectory';
import SopCompliance     from '../components/sopCompliance/SopCompliance';
import TableMonitoring   from '../components/tableMonitoring/TableMonitoring';
import ChartsRow         from '../components/charts/ChartsRow';
import DemographicAnalysis from '../components/charts/DemographicAnalysis';
import DashboardSkeleton  from '../components/ui/DashboardSkeleton';
import styles            from './Dashboard.module.css';

export default function Dashboard() {
  const { activeStore, currentStore, startDate, endDate, loading } = useDashboard();
  const [storeView, setStoreView] = useState('footfall');

  // Fetch SOP count for subnav badge
  const sopKey = currentStore ? `sop:${currentStore.storeId}:${startDate}:${endDate}:p1` : null;
  const { data: sopData } = useCache(sopKey, () => fetchSOP(currentStore.storeId, startDate, endDate, 1, 10));
  const sopCount = sopData
    ? (sopData.hygiene?.totalBreaches || 0) + (sopData.ppe?.totalNonCompliant || 0)
    : 0;

  // Single store (any date range) → render Demographic Analysis above Footfall Image Directory
  const showDemoAboveDirectory = activeStore && storeView === 'footfall';

  // While the initial store list is still loading, show a full-page shimmer.
  // (Placed after all hooks so hook order stays stable across renders.)
  if (loading) return <DashboardSkeleton />;

  return (
    <>
      <PageSubnav activeTab={storeView} onTabChange={setStoreView} sopCount={sopCount} />

      <main className={styles.main}>
        {!activeStore && <KpiGrid />}

        {activeStore ? (
          <>
            {storeView === 'footfall' && <TabKpiRow tab={storeView} />}
            {showDemoAboveDirectory && <ChartsRow />}
            {showDemoAboveDirectory && (
              <div className={styles.demoSection}>
                <DemographicAnalysis />
              </div>
            )}
            {storeView === 'footfall'    && <FootfallDirectory />}
            {storeView === 'compliance'  && <SopCompliance />}
            {storeView === 'table'       && <TableMonitoring />}
          </>
        ) : (
          <StorePerformance />
        )}

        {!activeStore && <ChartsRow />}
        {!activeStore && (
          <div className={styles.demoSection}>
            <DemographicAnalysis />
          </div>
        )}
      </main>
    </>
  );
}
